import React, { useState, useEffect } from "react";
import {
  Grid,
  makeStyles,
  Typography,
  TableContainer,
  Table,
  TableBody,
  Button,
  TablePagination,
} from "@material-ui/core";
import ReceiptIcon from "@material-ui/icons/Receipt";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { connect } from "react-redux";
import NumberFormat from "react-number-format";

import { calculateTotalSells, changeRowsPerPage } from "../_utils/utils";
import styles from "../styles/global-styles";
import { AuthService } from "../services/auth.service";
import { actions as actionsAlert } from "../redux/actions/alert";
import {
  clickCheckboxInSells,
  selectAllCheckboxInSells,
} from "../_utils/checkBox";
import TableHeadSellsWithCheckbox from "../components/stateless/headTables/TableHeadSellsWithCheckbox";
import { HeadCellSellsByUser } from "../components/stateless/headTables/HeadCellSellsByUser";
import ProductTableToolbar from "../components/shared/table/ProductTableToolbar";
import GenerateReceipt from "../components/core/modals/GenerateReceipt";
import { SiteService } from "../services/site.service";
import { createPDFReport } from "../components/core/reports/PdfSellsReport";
import SellsHeader from "../components/core/sells/SellsHeader";
import SellRow from "../components/core/sells/SellRow";
import TableHeadSells from "../components/stateless/headTables/TableHeadSells";
import { createTicketReport } from "../components/core/reports/TicketSellsReport";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  body: styles.body,
  subtitle: styles.subtitle,
}));

const ContainerSells = ({ addAlert, detailAlert, title, typeOfSells }) => {
  const classes = useStyles();

  const [queryParams, setqueryParams] = useState({});
  const [salesInfo, setSalesInfo] = useState({});
  const [datesSelected, setDatesSelected] = useState({});

  const [openReceiptModal, setopenReceiptModal] = useState(false);
  const [productsForReceipt, setProductsForReceipt] = useState([]);
  /**Check box options */
  const [selectedProducts, setSelectedProducts] = useState([]);
  /** Pagination */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  useEffect(() => {
    const { siteId, id } = AuthService.currentUserValue;
    if (!!siteId && !!id) {
      setqueryParams({ ...queryParams, siteId, userId: id });
    } else {
      AuthService.logout();
    }
  }, []);

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleGerenareteReceipt = async () => {
    try {
      const { data } = await SiteService.getSiteById(queryParams.siteId);
      let siteInfo = data[0];
      if (siteInfo.folio === null) {
        siteInfo = { ...siteInfo, folio: 1 };
      } else siteInfo = { ...siteInfo, folio: (siteInfo.folio += 1) };
      setqueryParams({ ...queryParams, siteInfo });
    } catch (error) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: error.msgs,
        time: 5000,
      });
    }

    let productsarray = [];
    salesInfo.salesArray.forEach((value) => {
      selectedProducts.forEach((sellId) => {
        if (sellId === value.id) productsarray.push(value);
      });
    });
    console.log("productsForReceipt", productsarray);
    setProductsForReceipt(productsarray);
    setopenReceiptModal(true);
  };

  const receiptGenerated = (receiptCreated, error) => {
    addAlert({ showAlert: true });
    if (receiptCreated) {
      setTimeout(() => window.location.reload(), 5000);
      detailAlert({
        severity: "success",
        message: "Factura creada exitosamente",
        time: 4900,
      });
    } else {
      detailAlert({
        severity: "error",
        message: error.info || error.msgs,
        time: 4900,
      });
    }
    setopenReceiptModal(false);
  };

  const handleClickCheckbox = (item) => {
    if (item.paymentMethodId === 5) return;

    if (!item.product.factureCreated) {
      const id = item.id;
      console.log("selectedProducts", selectedProducts);
      setSelectedProducts(clickCheckboxInSells(id, selectedProducts));
    } else {
      return;
    }
  };

  return (
    <>
      <SellsHeader
        title={title}
        salesInfo={(totalSales, salesArray, dates) => {
          setSalesInfo({ totalSales, salesArray });
          setDatesSelected({
            startDate: dates.startDate,
            endDate: dates.endDate,
          });
        }}
        typeOfSells={typeOfSells}
      />

      <Grid container direction="row" justify="flex-start" spacing={2}>
        {typeOfSells === "sellsByUser" && (
          <Grid item>
            <Button
              className={classes.rightButton}
              onClick={() => handleGerenareteReceipt()}
              variant="contained"
              disabled={!selectedProducts.length}
              color="primary"
              endIcon={<ReceiptIcon color="secondary" />}
            >
              Facturar
            </Button>
          </Grid>
        )}

        {salesInfo.totalSales > 0 && (
          <>
            <Grid item>
              <Button
                className={classes.rightButton}
                variant="contained"
                onClick={() =>
                  createPDFReport(
                    salesInfo.salesArray,
                    datesSelected.startDate,
                    datesSelected.endDate,
                    typeOfSells
                  )
                }
                color="primary"
                endIcon={<PictureAsPdfIcon color="secondary" />}
              >
                Generar reporte en PDF
              </Button>
            </Grid>

            <Grid item>
              <Button
                className={classes.rightButton}
                variant="contained"
                onClick={() =>
                  createTicketReport(
                    salesInfo.salesArray,
                    datesSelected.startDate,
                    datesSelected.endDate,
                    typeOfSells
                  )
                }
                color="primary"
                endIcon={<ReceiptIcon color="secondary" />}
              >
                Generar reporte en ticket
              </Button>
            </Grid>
          </>
        )}
      </Grid>

      {salesInfo.totalSales > 0 && typeOfSells === "sellsByUser" && (
        <Typography
          style={{ margin: "20px 0 10px 0" }}
          className={classes.body}
        >
          Total de mis ventas{" "}
          <NumberFormat
            value={calculateTotalSells(salesInfo.salesArray)}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
          />
        </Typography>
      )}

      <Grid>
        {typeOfSells === "sellsByUser" && (
          <ProductTableToolbar
            productsSelected={selectedProducts}
            title={""}
            label={" Producto(s) seleccionados"}
          />
        )}

        <TableContainer>
          {salesInfo.salesArray?.length > 0 ? (
            <Table className={classes.table} aria-label="customized table">
              {typeOfSells === "sellsByUser" ? (
                <TableHeadSellsWithCheckbox
                  numSelected={selectedProducts.length}
                  headCells={HeadCellSellsByUser}
                  onSelectAllClick={(e) =>
                    setSelectedProducts(
                      selectAllCheckboxInSells(
                        e,
                        salesInfo.salesArray,
                        "product"
                      )
                    )
                  }
                  rowCount={salesInfo.salesArray.length}
                />
              ) : (
                <TableHeadSells />
              )}
              <TableBody>
                {salesInfo.salesArray
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, i) => (
                    <SellRow
                      typeOfSells={typeOfSells}
                      key={i}
                      item={item}
                      i={i}
                      selectedProducts={selectedProducts}
                      clickCheckbox={handleClickCheckbox}
                    />
                  ))}
              </TableBody>
            </Table>
          ) : (
            <Typography
              variant="h6"
              component="h4"
              style={{ marginTop: 50 }}
              className={classes.subtitle}
            >
              Seleccionar los filtros de fecha para la búsqueda
            </Typography>
          )}
        </TableContainer>
        {salesInfo.salesArray?.length > 0 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={salesInfo.salesArray.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={(event) => {
              const { rowsPerPage, page } = changeRowsPerPage(event);
              setRowsPerPage(rowsPerPage);
              setPage(page);
            }}
          />
        )}

        {openReceiptModal && productsForReceipt.length >= 1 && (
          <GenerateReceipt
            siteInfo={queryParams.siteInfo}
            productsForReceipt={productsForReceipt}
            open={openReceiptModal}
            onClose={() => setopenReceiptModal(false)}
            receiptCreated={receiptGenerated}
          />
        )}
      </Grid>
    </>
  );
};

const dispatch = {
  detailAlert: actionsAlert.detailAlert,
  addAlert: actionsAlert.addAlert,
};

export default connect(null, dispatch)(ContainerSells);
